import { StatusType } from './StatusColorBar';

export const STATUS: { [key in string]: StatusType } = {
  GOOD: 'GOOD',
  WARNING: 'WARNING',
  DANGER: 'DANGER',
};
